import $ from 'jquery';

export default class Accordions {
    constructor() {
        $('.accordions-holder').find('.accordion').click(function(){
             if(!$(this).parent().hasClass('open')) {
                $(this).addClass('open').find('.content').slideDown();
                $(this).find('.accordions-title').addClass('active');
            }
        });

        $('.accordions-holder').find('.accordion .accordions-title').click(function(){
            if($(this).parent().hasClass('open')) {
                $(this).parent().removeClass('open').find('.content').slideUp();
                $(this).removeClass('active');
                return false;
            }
        });
    }
}

new Accordions();